import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setTranslation } from '../actions';
import TransHelper from 'components/common/translations/TransHelper';
import { matchPath } from "react-router";
import withRouter from 'components/components/common/withRouter';

class TranslateSwitch extends Component {

  checkHaveToRedirectToMainPage = () => {
    var url = TransHelper.translate(this.props.locale, "routes.url.blogArticle")
    return matchPath(this.props.location.pathname, {
      path: url,
      exact: true,
      strict: false
    });
  }

  handleSwitch = (e) => {
    var newLocale = e.currentTarget.dataset.name;

    if(this.checkHaveToRedirectToMainPage()){
      document.location = "/"+newLocale;
      return;
    }

    //change URL
    if(newLocale != this.props.locale){
      var currentPath = this.props.location.pathname;
      var newRoute    = TransHelper.findRouteTranslation(this.props.locale, newLocale, currentPath);

      if(newRoute != null && newRoute != "" && currentPath != "/"){
        this.props.history.replace(newRoute);
      }
      this.props.setTranslation(newLocale);
    }
  }

  render() {
    const { locale } = this.props;
    return (
      <div className='translate__switch'>
        <a
          data-name='de'
          onClick={this.handleSwitch}
          className={locale === 'de' ? 'active' : ''}>
          DE
        </a>
        <a
          data-name='en'
          onClick={this.handleSwitch}
          className={locale === 'en' ? 'active' : ''}>
          EN
        </a>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    locale: state.app.locale
  }
}

export default withRouter(connect(mapStateToProps, {setTranslation})(TranslateSwitch));
